'use client';

import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  /**
   * Size of the CircularProgress spinner
   * @default 40
   */
  size?: number;
  /**
   * Optional message to display below the spinner
   */
  message?: string;
  /**
   * ARIA label for accessibility
   * @default "Loading"
   */
  ariaLabel?: string;
}

/**
 * Full-page centered loading spinner for authentication guards and simple loading states
 * For page-level loading with overlays, use LoadingOverlay instead
 */
export function LoadingSpinner({
  size = 40,
  message,
  ariaLabel = 'Loading'
}: LoadingSpinnerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        gap: 2
      }}
      role="progressbar"
      aria-label={ariaLabel}
      aria-busy="true"
    >
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
}
